$(function() {
  var duration = 500;
  var duration2 = 500;

  var current_scrollY_start = $(window).scrollTop();

  // タブレットレイアウトをPCと統一
  var metaDiscre = document.head.children;
  var metaLength = metaDiscre.length;
  console.log('window:' + window.outerWidth);
  if(window.outerWidth > 700 && window.outerWidth < 1250){
    for(var i = 0;i < metaLength;i++){
       var proper = metaDiscre[i].getAttribute('name');
        if(proper === 'viewport'){
          console.log('tablet')
          var dis = metaDiscre[i];
          dis.setAttribute('content','width=1440');
        }
    }
  }

  function preSetScript() {

    // スクロール + ウィンドウサイズ系の対策処理
    function scrollAnimationSet(target) {
      const scButtonWrap = $('#scrollTopWrap');
      const fixedButton = $('#fixedButton');
      const header = $('#fixedHeader');
      const position = document.documentElement;
      let pageHeight;
      let wHeight = window.innerHeight;
      let preSetWidth = window.innerWidth;
      let scrollCount = 0;

      function setHeightProperty() {
        wHeight = window.innerHeight;
        pageHeight = $('body').innerHeight();
        position.style.setProperty('--wHeight', window.innerHeight);
        position.style.setProperty('--wHeightPx', window.innerHeight + 'px');
        position.style.setProperty('--scroll', window.scrollY);
        if (window.scrollY > 100) {
          header.addClass('rolled');
        } else {
          header.removeClass('rolled');
        }
        if (document.getElementById('bgWhite')) {
          var imgPos = $('#bgWhite').offset().top;
          var windowHeight = $(window).height();
          if (document.getElementById('whiteHeader')) {
            if (window.scrollY > imgPos - windowHeight + windowHeight / 10) {
              header.removeClass('white');
            } else {
              header.addClass('white');
            }
          }
          if (window.scrollY > imgPos - windowHeight + windowHeight / 5) {
            $('article').removeClass('black');
            $('#bgWhite').removeClass('effect');
          } else {
            $('article').addClass('black');
            $('#bgWhite').addClass('effect');
          }
        }
        /*$(".func-scroll-animation").each(function() {
          var imgPos = $(this).offset().top;
          var scroll = $(window).scrollTop();
          var windowHeight = $(window).height();
          if (scroll > imgPos - windowHeight + windowHeight / 4) {
            $(this).removeClass('effect');
          }
        });*/
        requestAnimationFrame(setProperties);
      }

      function setProperties() {
        setHeightProperty();
      }

      function init() {
        var timer = false;
        setProperties();
        position.style.setProperty('--wHeightFixedPx', window.innerHeight + 'px');
      }

      init();

    }

    scrollAnimationSet($('article'));


    // ハンバーガーメニューの開閉
    function humMenuControll(target) {
      var header = $('header');
      var humMenuState = 0;
      var humButton = $('#humButton');
      var hummenuState = 0;

      var hummenuNav = $('#hummenuNav');
      var navItem = [];
      var navButton = [];
      var navToggle = [];
      var toggleState = [];
      var currentToggle = -1;

      function hummenuOpen() {
        if(hummenuState == 0){
          target.addClass('open');
          humButton.addClass('hum_open');
          hummenuState = 1;
        }else{
          target.removeClass('open');
          humButton.removeClass('hum_open');
          hummenuState = 0;
        }
      }

      function init() {
        humButton.on({
          'click': function() {
            console.log('click');
            hummenuOpen();
          }
        });

        $.each(hummenuNav.find('.nav_item'), function(index) {
          navItem[index] = $(this);
          navButton[index] = $(this).find('button');
          navToggle[index] = $(this).find('.toggle_box');
          toggleState[index] = 0;
          navItem[index].css({'height': navButton[index].innerHeight() + 'px'});
          navButton[index].on({
            'click': function() {
              navToggleControll(index);
            }
          });
        });

      }

      init();
    }

    humMenuControll($('#humMenu'));


    //商品詳細ページ サムネイルの切り替え
    function thumbSwitcher(target){
      let thumbButton = [];
      let thumbSrc = [];
      let thumbSrcSet = [];
      let thumbBox = target.find('#thumbBox');
      let thumbImage = thumbBox.find('img');
      let slideNum = target.find('.thumbnails').find('img').length;
      const time = 200;
      let currentSlide = 0;
      console.log('slideNum:' + slideNum);

      function switchImage(num){
        console.log('num:' + num);
        thumbBox.stop().animate({ opacity: 0 }, time, function() {
            thumbImage.attr('src', thumbSrc[num]);
            thumbImage.attr('srcset', thumbSrcSet[num]);
            $('.active_thumb').removeClass('active_thumb');
            thumbButton[num].addClass('active_thumb');
            thumbBox.stop().animate({ opacity: 1 }, time);
        });
      }

      function thumbHeightControll(){
        var thumbHeight = thumbImage.outerHeight();
        $('#thumnails').css({'max-height': thumbHeight + 'px'});
        requestAnimationFrame(thumbHeightControll);
      }

      function slideNext(){
        if (currentSlide < slideNum - 1) {
          currentSlide = currentSlide + 1;
        } else {
          currentSlide = 0;
        }
        thumbButton[currentSlide].click();
        /*switchImage(currentSlide);*/
      };

      function slidePrev(){
        if (currentSlide == 0) {
          currentSlide = slideNum - 1;
        } else {
          currentSlide = currentSlide - 1;
        }
        thumbButton[currentSlide].click();
        /*switchImage(currentSlide);*/
      };

      function tabTouch(){
        if(startTouchX - endTouchX > 50){
          slideNext();
        }else if(startTouchX - endTouchX < - 50){
          slidePrev();
        }
      };

      function windowDrag() {
        if (startDragX - endDragX > 100) {
          slideNext();
        } else if (startDragX - endDragX < -100) {
          slidePrev();
        }
      };

      function init(){
        thumbHeightControll();
        $.each(target.find('.thumbnails').find('button'), function(index) {
          thumbButton[index] = $(this);
          thumbSrc[index] = $(this).find('img').attr("src");
          thumbSrcSet[index] = $(this).find('img').attr("srcset");
          thumbButton[index].on({
            'click': function() {
              switchImage(index);
            }
          });
        });

        thumbBox.find('img').on({
          'dragstart': function(e) {
            event.preventDefault();
            startDragX = event.pageX;
          },
          'dragend': function(e) {
            endDragX = event.pageX;
            windowDrag();
          }
        });

        thumbBox.find('img').on({
          'touchstart' : function(e){
            event.preventDefault();
            startTouchX = event.changedTouches[0].pageX;
          },
          'touchmove' : function(e){
          },
          'touchend' : function(e){
            endTouchX = event.changedTouches[0].pageX;
            tabTouch();
          }
        });

        $(window).on({
          'resize': function(){
            thumbHeightControll();
          }
        });
      }

      init();

    }

    if (document.getElementById('product')) {
      thumbSwitcher($('#prodImages'));
    }

    //商品詳細ページ 購入数の増減 & バリエーションの切り替え
    function cartWrapControll(){
      var minusButton = $('#minusButton');
      var plusButton = $('#plusButton');
      var quantityInput = $('#quantityInput');
      var quantityNum = 1;
      var optionSelector = $('#optionSelector');
      var optionLabel = [];
      var labelState = 0;

      var options = $('input[name=variation]');
      var optionID = []
      var selectBox = $('#ProductSelect-product-template');


      function controllQuantity(vector){
        quantityNum = quantityInput.val();
        if(vector == 1){
          quantityInput.attr('value', Number(quantityNum) + 1);
          quantityNum = quantityInput.val();
        }else{
          if(quantityNum != 1){
            quantityInput.attr('value', Number(quantityNum) - 1);
            quantityNum = quantityInput.val();
          }
        }
      }

      function changeProductOption(i,e){
        selectBox.val(e);
        $('.active_label').removeClass('active_label');
        if(labelState != i){
          optionLabel[i].addClass('active_label');
          labelState = i;
        }
      }

      function init(){

        minusButton.on({
          'click': function() {
            event.preventDefault();
            controllQuantity(-1);
          }
        });

        plusButton.on({
          'click': function() {
            event.preventDefault();
            controllQuantity(1);
          }
        });

        // 通常購入のサイズ切り替え
        $.each(optionSelector.find('label'), function(index) {
          optionLabel[index] = $(this);
          optionID[index] = $(this).find('input').val();
          labelState[index] = 0;
          optionLabel[index].on({
            'click': function() {
              console.log('optionID[index]:' + optionID[index]);
              event.preventDefault();
              changeProductOption(index,optionID[index]);
            }
          });
        });



      };

      init();

    }

    if (document.getElementById('product')) {
      cartWrapControll();
    }

    // 商品詳細ページ 蛇腹式レイアウト
    function toggleControl(target){
      let toggleItem = [];
      let toggleButton = [];
      let toggleContents = [];
      let toggleInner = [];
      let toggleType = [];
      let toggleState = [];
      let toggleState2 = [];
      let toggleInToggle = [];
      let windowWidth;
      let spWidth = 721;


      function toggleMove(e) {
        var buttonHeight = toggleButton[e].outerHeight();
        var tagetHeight = toggleInner[e].outerHeight();
        if (toggleState[e] == -1 || toggleState[e] == 0) {
          toggleButton[e].addClass('open');
          toggleContents[e].css({
            'height': tagetHeight + 'px'
          });
          toggleState[e] = 1;
        } else {
          toggleButton[e].removeClass('open');
          var toggleHeight = toggleButton[e].outerHeight();
            toggleContents[e].css({
              'height': 0 + 'px'
            });
          toggleState[e] = 0;
        }
      }

      function init(){
        windowWidth = $(window).width();
        $.each(target.find('.toggle_item'), function(index) {
          toggleItem[index] = $(this);
          toggleButton[index] = $(this).find('.toggle_button');
          toggleContents[index] = $(this).find('.toggle_contents');
          toggleInner[index] = $(this).find('.toggle_inner');
          toggleType[index] = toggleItem[index].attr('type');
          var tagetHeight = toggleInner[index].outerHeight();
          if(toggleType[index] == 'open'){
            toggleContents[index].css({'height': tagetHeight + 'px'});
            toggleState[index] = 1;
            toggleState2[index] = -1;
          }else if(toggleType[index] == 'close'){
            toggleContents[index].css({'height': 0 + 'px'});
            toggleState[index] = 0;
            toggleState2[index] = -1;
          }else{
            toggleContents[index].css({'height': tagetHeight + 'px'});
            toggleState[index] = 1;
            toggleState2[index] = -1;
          }
          toggleButton[index].on({
            'click': function() {
              toggleMove(index);
            }
          });

        });
      }

      init();

    }

    if (document.getElementById('product')) {
      toggleControl($('#toggles'))
    }

    //

    // 店舗一覧・FAQの目次ボタン
    function indexAnker(target){
      var ankerButton = [];
      var scrollTarget = [];

      function windowMove(e) {
        var headerHeight = $('header').outerHeight();
        var scrollHeight = $(scrollTarget[e]).offset().top;
        var adScroll = scrollHeight - headerHeight;
        $("html, body").animate({
          scrollTop: adScroll
        }, 500);
      }


      function init(){
        target.find('button').each(function(index) {
          ankerButton[index] = $(this);
          scrollTarget[index] = $(this).attr('jump');
          ankerButton[index].on({
            'click': function() {
              windowMove(index);
            }
          });
        });
      }

      init();

    }

    if (document.getElementById('stores')) {
      indexAnker($('#categoryList'));
    }

    if (document.getElementById('faq')) {
      indexAnker($('#categoryList'));
    }

    // FAQの開閉処理
    function faqToggle(target) {
      var toggleItem = [];
      var toggleButton = [];
      var toggleContents = [];
      var toggleState = [];
      var toggleTitleTxt = [];
      var toggleContentsTxt = [];
      var faqSearch = $('#faqSearch');
      var faqFlex = $('#faqContents');
      var windowW = window.innerWidth;

      function filterFaqItem(){
        var searchValue = faqSearch.val();
        $.each(target.find('.toggle_item'), function(index) {
          if(searchValue.length > 1){
            if(toggleTitleTxt[index].indexOf(searchValue) != -1 || toggleContentsTxt[index].indexOf(searchValue) != -1){
              $(this).css({'display': 'block'});
            }else{
              $(this).css({'display': 'none'});
            }
          }else{
            $(this).css({'display': 'block'});
          }
        });
        $.each(target.find('.comp-faq-contents'), function(index) {
          if(searchValue.length > 1){
            if($(this).text().indexOf(searchValue) != -1){
              $(this).css({'display': 'block'});
            }else{
              $(this).css({'display': 'none'});
            }
          }else{
            $(this).css({'display': 'block'});
          }
        });
        $.each(target.find('.item_wrap'), function(index) {
          if(searchValue.length > 1){
            if($(this).text().indexOf(searchValue) != -1){
              $(this).css({'display': 'block'});
            }else{
              $(this).css({'display': 'none'});
            }
          }else{
            $(this).css({'display': 'block'});
          }
        });
      }

      function toggleMove(e) {
        if ( toggleState[e] == 0 ) {
          toggleButton[e].addClass('active');
          var buttonHeight = toggleButton[e].innerHeight();
          var tagetHeight = toggleContents[e].innerHeight();
          toggleItem[e].css({
            'height': buttonHeight + tagetHeight + 'px'
          });
          toggleState[e] = 1;
        } else {
          toggleButton[e].removeClass('active');
          var buttonHeight = toggleButton[e].innerHeight();
            toggleItem[e].css({
              'height': buttonHeight + 2 + 'px'
            });
          toggleState[e] = 0;
        }
      }

      function setToggleHeight(){
        $.each(target.find('.toggle_item'), function(index) {
          toggleItem[index] = $(this);
          toggleButton[index] = $(this).find('.toggle_button');
          toggleContents[index] = $(this).find('.toggle_contents');
          $(this).css({'height': toggleButton[index].innerHeight() + 2 + 'px'});
          toggleState[index] = 0;
        });
      }

      function windowChecker(){
        var currentWindow = window.innerWidth;
        if(currentWindow != windowW){
          setToggleHeight();
          windowW = currentWindow
        }
        requestAnimationFrame(windowChecker);
      }

      function init() {
        $.each(target.find('.toggle_item'), function(index) {
          toggleItem[index] = $(this);
          toggleButton[index] = $(this).find('.toggle_button');
          toggleContents[index] = $(this).find('.toggle_contents');
          $(this).css({'height': toggleButton[index].innerHeight() + 2 + 'px'});
          toggleState[index] = 0;
          toggleTitleTxt[index] = toggleButton[index].text();
          toggleContentsTxt[index] = toggleContents[index].text();
          toggleButton[index].on({
            'click': function() {
              toggleMove(index);
            }
          });
        });
        if (document.getElementById('faq')) {
          faqSearch.on({
            'blur': function(){
              faqFlex.stop().animate({opacity: 0}, 300);
              setTimeout(function() {
                filterFaqItem();
                faqFlex.stop().animate({opacity: 1}, 300);
              }, 300);
            }
          });
        }
        windowChecker();
      }

      init();

    }

    if (document.getElementById('faq')) {
      faqToggle($('article'));
    }


    // 記事コンテンツのHTML整形
    function arrangeArticleHTML(target){

      function addTextLink(){
        $('.desc_wrap').each(function (idx, elem) {
          console.log('desc_wrap');
          let str = $(elem).html();
          let regexp_url = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g;
          let regexp_makeLink = function(all, url, h, href) {
            return '<a href="h' + href + '" target="_blank">' + url + '</a>';
          }
          let textWithLink = str.replace(regexp_url, regexp_makeLink);
          $(elem).html(textWithLink);
        });
      }

      function init(){
        target.find('a').each(function(index) {
          var hrefLink = $(this).attr('href');
          var replaceTxt = hrefLink.replace("https:", '');
          $(this).attr('href', replaceTxt);
        });
        addTextLink();
      }

      init();

    }

    if (document.getElementById('articleContent')) {
      arrangeArticleHTML($('#articleContent'));
    }

    /* ログインページの切り替えレイアウト */
    function switchLoginFunction(){
      var loginLayout = $('#login');
      var resetLayout = $('#reset');
      var resetPassword = $('#resetPassword');
      var loginBack = $('#loginBack');

      function switchLogin(){
        $('#contentSwitcher').animate({opacity:0}, 400, function(){
            loginLayout.css({'display': 'block'});
            resetLayout.css({'display': 'none'});
            setTimeout(function() {
              $("#contentSwitcher").animate({opacity: 1}, 400);
            }, 50);
        });
      }

      function switchReset(){
        $('#contentSwitcher').animate({opacity:0}, 400, function(){
            loginLayout.css({'display': 'none'});
            resetLayout.css({'display': 'block'});
            setTimeout(function() {
              $("#contentSwitcher").animate({opacity: 1}, 400);
            }, 50);
        });
      }

      function init(){

        resetPassword.on({
          'click': function() {
            event.preventDefault();
            switchReset();
          }
        });

        loginBack.on({
          'click': function() {
            event.preventDefault();
            switchLogin();
          }
        });

      }

      init();

    }

    if (document.getElementById('contentSwitcher')) {
      switchLoginFunction();
    }

    /* 住所一覧ページの切り替えレイアウト */
    function switchAddressFunction(){
      var addressContentWrap = $('#addressContentWrap');
      var wrapperList = $('#wrapperList');
      var wrapperAdd = $('#wrapperAdd');
      var addressList = $('#addressList');
      var addressEdit = $('#addressEdit');
      var adminBar = $('#adminBar');
      var editbutton = [];
      var editId = [];


      function switchList(){
        adminBar.removeClass('mode-edit').addClass('mode-list');
        window.scroll({top: 0, behavior: 'smooth'});
        addressContentWrap.animate({opacity:0}, 400, function(){
          $('.content_wrapper').css({'display': 'none'});
          wrapperList.css({'display': 'block'});
          addressContentWrap.css({'display': 'block'});
          setTimeout(function() {
            addressContentWrap.animate({opacity: 1}, 400);
          }, 50);
        });
      }

      function switchAdd(){
        adminBar.addClass('mode-edit').removeClass('mode-list');
        window.scroll({top: 0, behavior: 'smooth'});
        addressContentWrap.animate({opacity:0}, 400, function(){
            $('.content_wrapper').css({'display': 'none'});
            wrapperAdd.css({'display': 'block'});
            addressContentWrap.css({'display': 'block'});
            setTimeout(function() {
              addressContentWrap.animate({opacity: 1}, 400);
            }, 50);
        });
      }

      function switchEdit(e){
        adminBar.addClass('mode-edit').removeClass('mode-list');
        window.scroll({top: 0, behavior: 'smooth'});
        addressContentWrap.animate({opacity:0}, 400, function(){
            $('.content_wrapper').css({'display': 'none'});
            $('#' + editId[e]).css({'display': 'block'});
            addressContentWrap.css({'display': 'block'});
            setTimeout(function() {
              addressContentWrap.animate({opacity: 1}, 400);
            }, 50);
        });
      }

      function init(){
        addressList.on({
          'click': function() {
            event.preventDefault();
            switchList();
          }
        });

        addressEdit.on({
          'click': function() {
            event.preventDefault();
            switchAdd();
          }
        });

        $.each($('article').find('.btn_edit'), function(index) {
          editbutton[index] = $(this);
          editId[index] = $(this).attr('formId');
          editbutton[index].on({
            'click': function() {
              console.log(editId[index]);
              switchEdit(index);
            }
          });
        });

      }

      init();

    }

    if (document.getElementById('addressContentWrap')) {
      switchAddressFunction();
    }

  }

  preSetScript();

});
